import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpRequestMethods, IDP_APPS } from '../../constants/utils';
import {
  EndpointKeys,
  EndpointKeysCommon,
  Libraries
} from '../../constants/utils/app.constants';
import { OauthAEMConfig } from '../../models/login';
import { AEMTrackerContent } from '../../models/status-tracker/aem/overview.interface';
import { CommonConstants } from '../../models/status-tracker/status-tracker.constants';
import { ApiBuilder, AppConfigService, handleError } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  errorHandler = handleError.bind(this);
  authConfigJson!: Observable<OauthAEMConfig>;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getAuthConfigContent(): Observable<OauthAEMConfig> {
    if (this.authConfigJson) {
      return this.authConfigJson;
    } else {
      this.authConfigJson = this.getSkymilesAuthConfig().pipe(shareReplay(1));
      return this.authConfigJson;
    }
  }

  getSummaryContent = (): Observable<AEMTrackerContent> =>
    new ApiBuilder<undefined, AEMTrackerContent>(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_AEM_STATUS_TRACKER'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create();

  getSkymilesAuthConfig(): Observable<OauthAEMConfig> {
    return new ApiBuilder<undefined, OauthAEMConfig>(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeysCommon.SKYMILES_AEM_AUTH_CONFIG)
      .method(HttpRequestMethods['GET'])
      .timeOut(10000)
      .errorHandler(this.errorHandler)
      .library('SITEWIDE_STATUS_TRACKER')
      .create();
  }
}
